 function Spinner() {
    return <div
        className="spinner-border text-danger"
        role="status"
    >
        <span className="visually-hidden">Loading...</span>
    </div>
}

export default Spinner;